export interface WocUserSettingEditableFields {
  enableReceivingDailyReport?: boolean
  dailyReportSendingTime?: boolean
  monthlyReportEnabled?: boolean
  dailyReviewEnabled?: boolean
  subscribePayoutLineNotifyEnabled?: boolean
  weeklyOutOfStockReportEnabled?: boolean
}

export interface BusinessSetting {
  id: number
  userId: number
  restaurantId: number
  restaurantName: string
  dailyReportSendingTime: number
  dailyReportSendingTimeConvertMidnight: number
  enableReceivingDailyReport: boolean
  monthlyReportEnabled: boolean
  dailyReviewEnabled: boolean
  subscribePayoutLineNotifyEnabled: boolean
  weeklyOutOfStockReportEnabled: boolean
  userSettingsEditableFields?: WocUserSettingEditableFields
}

const EDITABLE_SETTING_FIELDS: (keyof WocUserSettingEditableFields)[] = [
  'enableReceivingDailyReport',
  'dailyReportSendingTime',
  'monthlyReportEnabled',
  'dailyReviewEnabled',
  'subscribePayoutLineNotifyEnabled',
  'weeklyOutOfStockReportEnabled',
]

export function isSettingFieldEditable(
  setting: BusinessSetting,
  field: keyof WocUserSettingEditableFields,
): boolean {
  return setting.userSettingsEditableFields?.[field] !== false
}

export function hasEditableSettingFields(setting: BusinessSetting): boolean {
  return EDITABLE_SETTING_FIELDS.some(field =>
    isSettingFieldEditable(setting, field),
  )
}

export interface UserSettingDetail {
  restaurantId: number
  enableReceivingDailyReport: boolean
  monthlyReportEnabled: boolean
  dailyReportSendingTime: number
  dailyReviewEnabled: boolean
  subscribePayoutLineNotifyEnabled: boolean
  weeklyOutOfStockReportEnabled: boolean
}

export interface PayoutNotificationDetail {
  userId: number
  restaurantId: number
  subscribePayoutLineNotifyEnabled: boolean
}
